const PREFIX = 'APP';

const ENVS = {
  TEST: {
    API: 'https://api.test.sessionstudio.com',
    WEB: 'https://app.test.sessionstudio.com/studio',
    NAME: 'TEST',
  },
  QA: {
    API: 'https://api.qa.sessionstudio.com',
    WEB: 'https://app.qa.sessionstudio.com/studio',
    NAME: 'QA',
  },
  PROD: {
    API: 'https://api.sessionstudio.com',
    WEB: 'https://app.sessionstudio.com/studio',
    NAME: 'PROD',
  },
};

module.exports = {
  ENVS,
  prefix: PREFIX,
  protocol: 'session-cc',
  channels: {
    APP_INFO: `${PREFIX}_GET_INFO`,
    APP_START: `${PREFIX}_START`,
    FORCE_QUIT: `${PREFIX}_QUIT`,
    ALLOW_QUIT: `${PREFIX}_ALLOW_QUIT`,
    WINDOW: {
      MAXIMIZE: `${PREFIX}_WINDOW_MAXIMIZE`,
      MINIMIZE: `${PREFIX}_WINDOW_MINIMIZE`,
      CLOSE: `${PREFIX}_WINDOW_CLOSE`,
    },
    REDIRECT: `${PREFIX}_REDIRECT`,
    TOGGLE_DARK_MODE: `${PREFIX}_TOGGLE_DARK_MODE`,
    IS_DARK_MODE: `${PREFIX}_IS_DARK_MODE`,
    IS_FULLSCREEN: `${PREFIX}_IS_FULLSCREEN`,
    EXECUTE_ACTION: `${PREFIX}_EXECUTE_ACTION`,
    OPEN_EXTERNAL_URL: `${PREFIX}_OPEN_EXTERNAL_URL`,
    OPEN_QR_WINDOW: `${PREFIX}_OPEN_QR_WINDOW`,
    GET_ELECTRON_CONFIG: `${PREFIX}_GET_ELECTRON_CONFIG`,
    SET_MINIMUM_APP_VERSION: `${PREFIX}_SET_MINIMUM_APP_VERSION`,
    SET_FORCE_UPDATE_READY: `${PREFIX}_SET_FORCE_UPDATE_READY`,
    SET_FORCE_UPDATE_NOT_READY: `${PREFIX}_SET_FORCE_UPDATE_NOT_READY`,
    TRIGGER_FORCE_UPDATE: `${PREFIX}_TRIGGER_FORCE_UPDATE`,
  },
};
